module.exports = __webpack_public_path__ + "static/coffee-beans-in-cup-6b60a0326813e72d09440a3a4a612d00.png";